(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name tracking.controller:TrackingCtrl
   *
   * @description
   *
   */
  angular
    .module('tracking')
    .controller('TrackingCtrl', TrackingCtrl);

  function TrackingCtrl($timeout, CommonMasterData, MessageService, TrackingRequestFactory, TrackingHelper, EventManagerService, TrackingModel, PopupManager, RemoteService, FlightWatch) {
    var vm = this;
    vm.view = "TRACKING";

    vm.model = {
      isFilterActive: false,
      isSearchPanelOpen: false,
      filter: [],
      crewBase: [],
      airports: [],
      aircraftTypes: [],
      flightSearchRequest: null,
      trackingFlights: TrackingHelper.trackingFlights(),
      filterSearchParam: null
    };

    vm.popUpDetails = {};
    vm.popUpDetails.airCraftDetails = '';
    vm.popUpDetails.relatedAirCraft = '';
    vm.popUpDetails.approachTypes = '';
    vm.selectedFlightLegDep = null;
    vm.selectedFlightLegOrigin = null;

    TrackingHelper.loadAirports();
    TrackingHelper.loadAircraftTypes();
    TrackingHelper.loadCrewBase();
    TrackingHelper.getCrewTypes();

    TrackingModel.isRegNumberFilterActive.subscribe(function (isActiveFlag) {
      vm.model.isFilterActive = isActiveFlag;
    });

    TrackingModel.flightSearchCriteria.subscribe(function () {
      vm.model.isSearchPanelOpen = false;
    });


    //send crew notification event
    EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.CREW_WATCH_SEND_CREW_NOTIFICATION, function (data) {
      vm.selectedAirCraft = data.items.flight;
      vm.slectedFlightLegId = data.items.flight.flightLegId;
      vm.selectedFlightLegOrigin = data.items.flight.origin;
      vm.selectedFlightLegDep = data.items.flight.destination;
      vm.loadSelectedFlightLegDetails();
    });


    //load selected flight leg details
    vm.loadSelectedFlightLegDetails = function () {

      FlightWatch.getAirCraftDetails(vm.slectedFlightLegId,
        function (response) {
          vm.popUpDetails.airCraftDetails = response.flightDetResponceDto;
          vm.selectedFlightLegOrigin = vm.popUpDetails.airCraftDetails.originApt;
          vm.popUpDetails.fuelSuppliers = vm.model.fuelSuppliers;
          vm.popUpDetails.airports = vm.model.airports;
          vm.popUpDetails.delayCodeDetails = response.delayCodeAdaptDTOs;
          FlightWatch.loadAircraftListByCode(vm.selectedAirCraft.modelNo,
            function (response) {
              vm.popUpDetails.relatedAirCraft = response;
              CommonMasterData.approachTypes(
                function (response) {
                  vm.popUpDetails.approachTypes = response;
                  vm.openCrewNotificationPopUp();
                }, function () {

                }
              );
            },
            function () {
              console.log('Open Flight search retrieval error');
            })

        },
        function (response) {

        }
      );

    }

    //get crew notification popup
    vm.openCrewNotificationPopUp = function () {
      PopupManager.openModal('FLIGHT_SEND_NOTIFICATION', vm.popUpDetails, null);
    }

  }

  $(window).resize(function () {
    var height = ($("header").height() + $(".tabbed-view-container").height()) + "px";
    $(".tracking-view .canvas").css("top", height);
  });
}());
